import React from 'react';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import { Link as RouterLink } from 'react-router-dom';

const useStyles = makeStyles(() => {
    return createStyles({
        logo: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        },
        svg: {
            fill: '#fff',
        },
        title: {
            fontWeight: 600,
            textDecoration: 'none',
            fontSize: '18px',
            color: '#fff',
        },
        logoLink: {
            textDecoration: 'none',
        },
    });
});

export const Logo: React.FC<any> = (props) => {
    const classes = useStyles();
    return (
        <RouterLink className={classes.logoLink} to="/">
            <div className={classes.logo}>
                {/*<svg width="61" height="24" viewBox="0 0 61 24" fill="none" xmlns="http://www.w3.org/2000/svg">*/}
                {/*    <path fill-rule="evenodd" clip-rule="evenodd" d="M60.9445 0C55.314 0.446472 49.6834 0.892944 41.943 1.3856C34.2026 1.87826 24.4795 2.4325 17.1331 2.21696C11.3831 2.02021 5.65458 1.27896 0 0C1.77106 2.0585 3.86208 3.67031 6.15165 4.74184C10.451 6.45987 14.9755 7.20103 19.4972 6.92801C26.7845 6.60405 34.0478 5.72476 41.244 4.29537C48.4887 3.01753 54.6531 1.50877 60.9445 0Z" fill="#0043C4"/>*/}
                {/*    <path fill-rule="evenodd" clip-rule="evenodd" d="M59.676 4.2323C51.3384 5.79098 43.052 7.34965 37.3232 8.40733C31.5943 9.465 28.6148 9.799 25.6609 10.0356C22.9322 10.2532 20.1926 10.2532 17.464 10.0356C15.4321 9.81344 13.4158 9.44618 11.4282 8.93616C13.882 10.2209 16.4538 11.2192 19.1008 11.9143C22.9783 12.8222 26.9381 13.247 30.9038 13.1808C34.9661 13.0246 39.0174 12.6251 43.0393 11.9839L49.7783 11.0793C48.8003 12.4722 48.0637 14.0473 47.6045 15.7275C47.2802 17.3945 47.3774 19.126 47.8858 20.7376C48.2958 21.8846 48.9435 22.9133 49.7783 23.7436C50.3013 21.1504 51.033 18.6124 51.965 16.159C53.0163 13.6997 54.3021 11.3674 55.8013 9.20058C56.9961 7.45645 58.2767 5.78399 59.6376 4.19055" fill="#0043C4"/>*/}
                {/*</svg>*/}

                <h1 className={classes.title} style={{ color: props.color ? props.color : '#fff' }}>
                    GoPost
                </h1>
            </div>
        </RouterLink>
    );
};

export default Logo;
